module.exports = __webpack_public_path__ + "img/profile.484eb632.svg";